import { createSlice } from "@reduxjs/toolkit";

const initialMerchantState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: [],
    merchantForEdit: undefined,
    lastError: null,
    message: null,
    currentTab: "accounts",
    error: null,
};
export const callTypes = {
    list: "list",
    action: "action"
};

export const merchantSlice = createSlice({
    name: "merchants",
    initialState: initialMerchantState,
    reducers: {
        catchError: (state, action) => {
            state.error = action.payload.error.clientMessage;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            state.message = null;

            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        endCall: (state, action) => {
            state.error = null;
            state.message = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        // getMerchantById
        merchantFetched: (state, action) => {
            state.actionsLoading = false;
            state.merchantForEdit = action.payload.merchantForEdit;
            state.floorPlans = action.payload.merchantForEdit.floorPlans;
            state.error = null;

        },
        // getMerchantChart
        merchantChartFetched: (state, action) => {

            state.actionsLoading = false;
            state.merchantChart = action.payload.merchantChart;
            state.error = null;

        },
        // getMerchantChart
        merchantHourlyChartFetched: (state, action) => {
            state.actionsLoading = false;
            state.merchantChartHour = action.payload.merchantChartHour;
            state.error = null;

        },
        // getMerchantChart
        merchantHourlyZoneChartFetched: (state, action) => {
            state.actionsLoading = false;
            state.merchantChartHourZone = action.payload.merchantChartHourZone;
            state.error = null;

        },
        // get list data
        merchantsFetched: (state, action) => {
            const { totalCount, entities } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            state.totalCount = totalCount;
            state.merchantForEdit = undefined;
            state.floorPlans = undefined;
            state.merchantChart = undefined;
            state.merchantChartHour = undefined;
            state.merchantChartHourZone = undefined;
        },
        // createMerchant
        merchantCreated: (state, action) => {
            state.actionsLoading = false;
            state.error = null;
            state.message = action.payload.msgResponse;
        },
        // updateMerchant
        merchantUpdated: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.message = action.payload.msgResponse;
        },
        // merchantDeleted
        merchantDeleted: (state, action) => {
            state.error = null;
            state.message = action.payload.msgResponse;
            state.actionsLoading = false;
        },
        userCreated: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.message = action.payload.msgResponse;
        },
        setMessage: (state, action) => {
            state.error = null;
            state.message = action.payload.msgResponse;
        },
        setTab: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.currentTab = action.payload.tab;
        },

    }
});
